if (!customElements.get('trusted-worldwide-scroll')) {
  customElements.define(
    'trusted-worldwide-scroll',
    class TrustedWorldwideScroll extends HTMLElement {
      connectedCallback() {
        if (this.offsetParent === null) return;

        const wrap = this.querySelector('.trusted-scroll-wrap');
        if (!wrap) return;

        const groups = Array.from(wrap.querySelectorAll('.trusted-scroll-group'));
        if (!groups.length) return;

        const totalGroupWidth = groups.reduce((acc, group) => acc + group.offsetWidth, 0);
        if (!totalGroupWidth) return;

        let totalWidth = totalGroupWidth;

        while (totalWidth < window.innerWidth * 2) {
          const newGroups = groups.map((group) => group.cloneNode(true));
          wrap.append(...newGroups);
          totalWidth += totalGroupWidth;
        }
      }
    }
  );
}
